import { type ChangeEventHandler, useRef, useState } from "react";
import { FaMagnifyingGlass } from "react-icons/fa6";
import { TextInput } from "@mantine/core";
import { useDebouncedCallback } from "@mantine/hooks";
import { useTheme } from "@contexts/ThemeContext";

export type OnSubmitHandler = (value: string) => void;

type SearchInputProps = {
  onSubmit: OnSubmitHandler;
  defaultValue?: string;
};

const SearchInput = ({ onSubmit, defaultValue = "" }: SearchInputProps) => {
  const { colors: themeColors } = useTheme();
  const [value, setValue] = useState(defaultValue);
  const textInputRef = useRef<HTMLInputElement>(null);

  const debounceOnChange = useDebouncedCallback((value) => {
    onSubmit(value);
  }, 300);

  const handleInputChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    setValue(e.target.value);
    debounceOnChange(e.target.value);
  };

  return (
    <TextInput
      type="text"
      placeholder="Search..."
      value={value}
      onChange={handleInputChange}
      leftSection={<FaMagnifyingGlass size={14} style={{ color: themeColors.inputPlaceholder }} />}
      size="md"
      ref={textInputRef}
      styles={{
        input: {
          backgroundColor: themeColors.inputBackground,
          color: themeColors.inputText,
          borderColor: themeColors.inputBorder,
          '::placeholder': {
            color: themeColors.inputPlaceholder,
          }
        }
      }}
    />
  );
};

export default SearchInput;
